module.exports = __webpack_public_path__ + "img/WCU_Main-new-1.00b78992.svg";